import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
var OneTimeGuard = /** @class */ (function () {
    function OneTimeGuard(router) {
        this.router = router;
    }
    OneTimeGuard.prototype.canActivate = function (route, state) {
        // 未ログイン
        if (!localStorage.getItem('currentUser')) {
            return false;
        }
        var user = JSOG.parse(localStorage.getItem('currentUser'));
        // 仮PASSの場合はOK
        if (user && user['isTemporaryPass']) {
            return true;
        }
        // ワンタイムパスワード未認証
        if (user && (typeof user['isOneTimeAuthenticated'] === 'undefined' || user['isOneTimeAuthenticated'] == false)) {
            if (user['authType'] === 'PASSMAIL') {
                // ワンタイム認証方式で未認証
                this.router.navigate(['/onetimelogin']);
                return false;
            }
        }
        return true;
    };
    OneTimeGuard.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    OneTimeGuard.ctorParameters = function () { return [
        { type: Router }
    ]; };
    return OneTimeGuard;
}());
export { OneTimeGuard };
//# sourceMappingURL=onetime.guard.js.map